<template>
  <b-container>
    <!-- <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row> -->
    <h2>{{ $t("userProfile.userProfile") }}</h2>

    <base-row-detail
      :label="$t('userProfile.loginName')"
      :value="`${this.model.loginName}`"
      readonly
    ></base-row-detail>

    <base-row-detail
      :label="$t('userProfile.namePresentation')"
      :value="`${this.model.namePresentation}`"
    ></base-row-detail>

    <base-row-detail
      :label="$t('userProfile.email')"
      :value="`${this.model.email}`"
    ></base-row-detail>

    <base-row-detail
      :label="$t('userProfile.cellphone')"
      :value="`${this.model.cellphone}`"
    ></base-row-detail>

    <base-row-detail
      :label="$t('userProfile.phone')"
      :value="`${this.model.phone}`"
    ></base-row-detail>

    <b-row class="mb-3 ml-0">
      <router-link :to="getEditProfile">
        <b-button size="sm">Editar perfil</b-button>
      </router-link>

      <router-link :to="getChangePassword" class="ml-2">
        <b-button size="sm">Alterar senha</b-button>
      </router-link>
    </b-row>
  </b-container>
</template>
<script>
import BaseRowDetail from "@/components_rms/base/BaseRowDetail.vue";
export default {
  name: "UserProfile",
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    BaseRowDetail,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
    };
  },
  readonlyMain: true,
  isBusy: false,
  modelstate: {},
  model: {
    loginName: "",
    namePresentation: "",
    email: "",
    cellphone: "",
    phone: "",
  },
  created() {
    // this.loadProfile();
    this.myProvider();
  },
  computed: {
    getEditProfile() {
      return `../user/profileEdit/`;
    },
    getChangePassword() {
      return `../user/changePassword/`;
    },
  },
  methods: {
    myProvider() {
      this.isBusy = true;
      console.log();
      return this.$apiScheduler
        .get("/v1/profileDetalied")
        .then((data) => {
          console.log(data.data);
          this.model = data.data;
          this.isBusy = false;
          return model;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.logo(error.response);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
  },
  watch: {
    model() {
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.cargo-data-row span {
  color: #c0c1c2;
  line-height: 13px;
  text-transform: none;
  margin-left: 10px;
}
</style>